import { render, staticRenderFns } from "./ItemAccessoryBuilderCard.vue?vue&type=template&id=357516df&"
import script from "./ItemAccessoryBuilderCard.vue?vue&type=script&lang=ts&"
export * from "./ItemAccessoryBuilderCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports